import { storageService } from '../services/storageService';

export interface PasswordExpiryCheck {
    shouldShowDialog: boolean;
    daysUntilExpiry: number;
    isPasswordExpired: boolean;
}

export const passwordExpiryUtils = {
    checkPasswordExpiry: (): PasswordExpiryCheck => {
        const expiryData = storageService.getPasswordExpiry();
        
        if (!expiryData) {
            return {
                shouldShowDialog: false,
                daysUntilExpiry: 0,
                isPasswordExpired: false,
            };
        }

        const { password_expired, password_expiry_date, dialog_shown } = expiryData;
        
        // If dialog has already been shown, don't show it again
        if (dialog_shown) {
            return {
                shouldShowDialog: false,
                daysUntilExpiry: 0,
                isPasswordExpired: false,
            };
        }
        
        // If password is already expired
        if (password_expired) {
            return {
                shouldShowDialog: true,
                daysUntilExpiry: 0,
                isPasswordExpired: true,
            };
        }

        // Calculate days until expiry
        const expiryDate = new Date(password_expiry_date);
        const currentDate = new Date();
        const timeDiff = expiryDate.getTime() - currentDate.getTime();
        const daysUntilExpiry = Math.ceil(timeDiff / (1000 * 3600 * 24));

        // Show dialog if 5 days or less until expiry
        const shouldShowDialog = daysUntilExpiry <= 5 && daysUntilExpiry >= 0;

        return {
            shouldShowDialog,
            daysUntilExpiry: Math.max(0, daysUntilExpiry),
            isPasswordExpired: false,
        };
    },

    // Mark dialog as shown
    markDialogAsShown: () => {
        const expiryData = storageService.getPasswordExpiry();
        if (expiryData) {
            storageService.setPasswordExpiry({
                ...expiryData,
                dialog_shown: true,
            });
        }
    },

    // Clear password expiry data (useful after password change)
    clearPasswordExpiry: () => {
        localStorage.removeItem('password_expiry');
    },
};
